<template>
  <vk-modal v-on="$listeners">
    <vk-modal-body>
      <vk-modal-header class="p-0 p-l-6:mo text-center:mo">
        Action Items
      </vk-modal-header>
      <vk-modal-content class="p-0">
        <div
            v-for="warning in warnings"
            :key="warning.code"
            class="d-flex ai-center p-2 bd-b-gray30">
          <div class="d-flex fd-column p-r-4:t">
            <div class="d-flex w-100 jc-between ai-center m-b-1">
              <div class="h6 text-bold c-gray80">{{ warning.extra_info.header }}</div>
              <div class="link flex-0-0 d-none:t" @click="ctaClicked(warning)">
                {{ warning.extra_info.short_cta }}
              </div>
            </div>
            <div>
              <span class="d-none:t">{{ warning.extra_info.short_text }}</span>
              <span class="d-none:mo">{{ warning.extra_info.full_text }}</span>
            </div>
          </div>
          <button class="flex-0-0 btn d-none:mo" @click="ctaClicked(warning)">
            {{ warning.extra_info.short_cta }}
          </button>
        </div>
      </vk-modal-content>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
export default {
  name: 'warnings-overview-modal',
  props: {
    warnings: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ctaClicked (warning) {
      this.$emit('cta-clicked', warning);
    },
  },
};
</script>
